/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import QualityIssuesPopover from './QualityIssuesPopover'

interface WrapperOverlayProps {
  row: {
    id: number
    [key: string]: any
  }
  isSuperseded?: boolean
}

/**
 * WrapperOverlay component wraps the QualityIssuesPopover component.
 * It provides a clean interface for rendering the quality issue indicator in table rows.
 *
 * This is the TypeScript/React 18 version migrated from the legacy
 * lego/page/browser/list/quality-issues/WrapperOverlay.jsx
 */
const WrapperOverlay: React.FC<WrapperOverlayProps> = ({ row, isSuperseded = false }) => {
  return (
    <span>
      <QualityIssuesPopover fsiId={row?.id} isSuperseded={isSuperseded} />
    </span>
  )
}

export default WrapperOverlay
